import { createCSSTheme, createTheme } from "./utils"

export const { theme, vars, literals } = createTheme({
  borderRadius: {
    literals: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      6: "6px",
      8: "8px",
      10: "10px",
      12: "12px",
      "50%": "50%",
      "100%": "100%",
      inherit: "inherit"
    }
  },
  borderStyle: {
    literals: {
      none: "none",
      dashed: "dashed",
      solid: "solid"
    }
  },
  borderWidth: {
    literals: {
      0: "0px",
      1: "1px",
      2: "2px",
      3: "3px"
    }
  },
  boxShadow: {
    literals: { none: "none" },
    varPrefix: "box-shadow",
    vars: {
      "-1": "0px 1px 0px 0px rgba(0, 0, 0, 0.08) inset",
      "1": "0px 1px 0px 0px rgba(0, 0, 0, 0.04)",
      "2": "0px 2px 1px 0px rgba(0, 0, 0, 0.05)",
      "3": "0px 2px 10px 0px rgba(0, 0, 0, 0.1)",
      "4": "0px 26px 80px 0px rgba(0, 0, 0, 0.2)",
      purpleFocus: "0px 0px 0px 2px rgba(124, 102, 220, 0.3)", // purple10.light
      purpleHighlight: "0px 0px 0px 4px rgb(228, 222, 252)",
      ghostFocus: "0px 0px 0px 3px rgba(111, 110, 119, 0.3)", // grey11.light
      greenFocus: "0px 0px 0px 2px rgba(48, 164, 108, 0.3)", // green9.light
      amberFocus: "0px 0px 0px 2px rgba(255, 178, 36, 0.3)", // amber9.light
      tomatoFocus: "0px 0px 0px 2px rgba(229, 77, 46, 0.3)", // tomato9.light
      tomatoHighlight: "0px 0px 0px 4px rgb(253, 216, 211)", // tomato5.light
      indigoFocus: "0px 0px 0px 2px rgba(174, 192, 245, 0.3)", // indigo7.light
      gradient: {
        light: "0px 0px 10px 10px rgb(249, 248, 249)", // grey2.light
        dark: "0px 0px 10px 10px rgb(28, 28, 31)" // grey2.dark
      },
      greyFocus: "0px 0px 0px 2px rgba(244, 242, 244, 0.3)", // grey3.light
      cropper: "0 0 0 9999em"
    }
  },
  color: {
    literals: {
      currentColor: "currentColor",
      transparent: "transparent",
      inherit: "inherit",
      white: "white",
      black: "black"
    },
    vars: {
      grey1: { light: "rgb(255, 255, 255)", dark: "rgb(22, 22, 24)" },
      grey2: { light: "rgb(249, 248, 249)", dark: "rgb(28, 28, 31)" },
      grey3: { light: "rgb(244, 242, 244)", dark: "rgb(35, 35, 38)" },
      grey4: { light: "rgb(238, 237, 239)", dark: "rgb(40, 40, 44)" },
      grey5: { light: "rgb(233, 232, 234)", dark: "rgb(46, 46, 50)" },
      grey6: { light: "rgb(228, 226, 228)", dark: "rgb(52, 52, 58)" },
      grey7: { light: "rgb(220, 219, 221)", dark: "rgb(62, 62, 68)" },
      grey8: { light: "rgb(200, 199, 203)", dark: "rgb(80, 79, 87)" },
      grey9: { light: "rgb(144, 142, 150)", dark: "rgb(112, 111, 120)" },
      grey10: { light: "rgb(134, 132, 141)", dark: "rgb(126, 125, 134)" },
      grey11: { light: "rgb(111, 110, 119)", dark: "rgb(160, 159, 166)" },
      grey12: { light: "rgb(26, 21, 35)", dark: "rgb(237, 237, 239)" },

      dark12: { light: "rgb(237, 237, 239)", dark: "rgb(237, 237, 239)" },

      indigo2: { light: "rgb(248, 250, 255)", dark: "rgb(21, 25, 45)" },
      indigo4: { light: "rgb(230, 237, 254)", dark: "rgb(28, 39, 79)" },
      indigo5: { light: "rgb(217, 226, 252)", dark: "rgb(31, 44, 92)" },
      indigo7: { light: "rgb(174, 192, 245)", dark: "rgb(39, 62, 137)" },
      indigo8: { light: "rgba(141, 164, 239)", dark: "rgba(47, 78, 178)" },
      indigo10: { light: "rgb(58, 92, 204)", dark: "rgb(83, 115, 231)" },
      indigo11: { light: "rgb(52, 81, 178)", dark: "rgb(132, 157, 255)" },
      indigo12: { light: "rgb(16, 29, 70)", dark: "rgb(238, 241, 253)" },

      green3: { light: "rgb(233, 249, 238)", dark: "rgb(15, 41, 30)" },
      green4: { light: "rgb(221, 243, 228)", dark: "rgb(17, 49, 35)" },
      green9: { light: "rgb(48, 164, 108)", dark: "rgb(48, 164, 108)" },
      green10: { light: "rgb(41, 151, 100)", dark: "rgb(60, 177, 121)" },
      green11: { light: "rgb(24, 121, 78)", dark: "rgb(76, 195, 138)" },
      green12: { light: "rgb(21, 50, 38)", dark: "rgb(229, 251, 235)" },

      amber3: { light: "rgb(255, 244, 213)", dark: "rgb(52, 28, 0)" },
      amber4: { light: "rgb(255, 236, 188)", dark: "rgb(63, 34, 0)" },
      amber9: { light: "rgb(255, 178, 36)", dark: "rgb(255, 178, 36)" },
      amber10: { light: "rgb(255, 160, 28)", dark: "rgb(255, 203, 71)" },
      amber11: { light: "rgb(173, 87, 0)", dark: "rgb(241, 161, 13)" },
      amber12: { light: "rgb(78, 32, 9)", dark: "rgb(254, 243, 221)" },

      tomato1: { light: "rgb(255, 252, 252)", dark: "rgb(29, 20, 18)" },
      tomato2: { light: "rgb(255, 248, 247)", dark: "rgb(42, 20, 16)" },
      tomato3: { light: "rgb(255, 240, 238)", dark: "rgb(59, 24, 19)" },
      tomato4: { light: "rgb(255, 230, 226)", dark: "rgb(72, 26, 20)" },
      tomato5: { light: "rgb(253, 216, 211)", dark: "rgb(84, 28, 21)" },
      tomato6: { light: "rgb(250, 199, 190)", dark: "rgb(101, 32, 22)" },
      tomato7: { light: "rgb(243, 176, 162)", dark: "rgb(127, 35, 21)" },
      tomato8: { light: "rgb(234, 146, 128)", dark: "rgb(164, 42, 18)" },
      tomato9: { light: "rgb(229, 77, 46)", dark: "rgb(229, 77, 46)" },
      tomato10: { light: "rgb(219, 67, 36)", dark: "rgb(236, 94, 65)" },
      tomato11: { light: "rgb(202, 50, 20)", dark: "rgb(241, 106, 80)" },
      tomato12: { light: "rgb(52, 23, 17)", dark: "rgb(254, 239, 236)" },

      purple1: { light: "rgb(253, 252, 254)", dark: "rgb(23, 21, 31)" },
      purple2: { light: "rgb(251, 250, 255)", dark: "rgb(28, 23, 43)" },
      purple3: { light: "rgb(245, 242, 255)", dark: "rgb(37, 30, 64)" },
      purple4: { light: "rgb(237, 233, 254)", dark: "rgb(44, 34, 80)" },
      purple5: { light: "rgb(228, 222, 252)", dark: "rgb(50, 39, 95)" },
      purple6: { light: "rgb(215, 207, 249)", dark: "rgb(57, 44, 114)" },
      purple7: { light: "rgb(196, 184, 243)", dark: "rgb(68, 53, 146)" },
      purple8: { light: "rgb(170, 153, 236)", dark: "rgb(88, 66, 195)" },
      purple9: { light: "rgb(110, 86, 207)", dark: "rgb(110, 86, 207)" },
      purple10: { light: "rgb(100, 79, 193)", dark: "rgb(124, 102, 220)" },
      purple11: { light: "rgb(87, 70, 175)", dark: "rgb(158, 140, 252)" },
      purple12: { light: "rgb(32, 19, 75)", dark: "rgb(241, 238, 254)" },

      greyAlpha1: {
        light: "rgba(0, 0, 0, 0.3)",
        dark: "rgba(0, 0, 0, 0.3)"
      },

      logoPurple: { light: "rgb(215, 126, 234)", dark: "rgb(215, 126, 234)" },
      logoBlue: { light: "rgb(123, 143, 236)", dark: "rgb(123, 143, 236)" },
      logoYellow: { light: "rgb(246, 202, 68)", dark: "rgb(246, 202, 68)" },
      logoRed: { light: "rgb(229, 87, 56)", dark: "rgb(229, 87, 56)" }
    }
  },
  cursor: {
    literals: {
      default: "default",
      move: "move",
      pointer: "pointer",
      text: "text",
      grab: "grab",
      notAllowed: "not-allowed",
      initial: "initial"
    }
  },
  fontFamily: {
    literals: { inherit: "inherit" },
    varPrefix: "font-family",
    vars: {
      body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace"
    }
  },
  gradient: {
    varPrefix: "gradient",
    vars: {
      "checker-board": {
        dark: "repeating-conic-gradient(hsl(248, 5%, 33%) 0% 25%, hsl(240, 5%, 12%) 0% 50%) 50% / 10px 10px",
        light:
          "repeating-conic-gradient(hsl(255, 4%, 79%) 0% 25%, hsl(300, 8%, 97%) 0% 50%) 50% / 10px 10px"
      }
    }
  },
  opacity: {
    literals: {
      0: "0",
      0.1: "0.1",
      0.3: "0.3",
      0.4: "0.4",
      0.5: "0.5",
      0.6: "0.6",
      0.8: "0.8",
      0.9: "0.9",
      1: "1"
    }
  },
  size: {
    varPrefix: "size",
    vars: {
      small: "28px", // The height of a small Button in the DS.
      medium: "32px", // The height of a medium Button in the DS.
      large: "40px", // The height of a large Button in the DS.
      scrollbar: "12px" // The height of the custom scrollbar
    }
  },
  space: {
    literals: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      6: "6px",
      8: "8px",
      10: "10px",
      12: "12px",
      16: "16px",
      18: "18px",
      20: "20px",
      24: "24px",
      28: "28px",
      32: "32px",
      40: "40px",
      48: "48px",
      72: "72px",
      80: "80px",
      100: "100px"
    },
    varPrefix: "space",
    vars: {
      fieldSetGap: "16px" // The gap in the FieldSet component
    }
  },
  transitionDuration: {
    literals: {
      0: "0ms",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      250: "250ms",
      300: "300ms",
      400: "400ms"
    }
  },
  zIndex: {
    // Forbid using z-indexes.
    literals: {}
  }
})

type Theme = typeof theme

// Ensures we keep a typesafe, documented link between components and theme.
export type ThemeKeys<
  Name extends keyof Theme,
  Keys extends keyof Theme[Name] = keyof Theme[Name]
> = Keys

// CSS theme (i.e which values are valid inside CSS files)
// This is used in the Stylelint config file to ensure only valid theme values are used.
export const cssTheme = createCSSTheme(vars, literals, {
  borderRadius: [
    "border-radius",
    "border-bottom-right-radius",
    "border-bottom-left-radius",
    "border-top-right-radius",
    "border-top-left-radius"
  ],
  borderStyle: [
    "border-style",
    "border-top-style",
    "border-bottom-style",
    "border-right-style",
    "border-left-style",
    "outline-style"
  ],
  borderWidth: [
    "border-width",
    "border-bottom-width",
    "border-right-width",
    "outline-width"
  ],
  boxShadow: ["box-shadow"],
  cursor: ["cursor"],
  color: [
    "background",
    "background-color",
    "fill",
    "border-color",
    "border-top-color",
    "border-bottom-color",
    "border-right-color",
    "color",
    "stroke",
    "outline-color"
  ],
  fontFamily: ["font-family"],
  gradient: ["background"],
  opacity: ["opacity"],
  size: [],
  space: [
    "gap",
    "margin",
    "margin-block",
    "margin-top",
    "margin-bottom",
    "margin-inline",
    "margin-left",
    "margin-right",
    "padding",
    "padding-block",
    "padding-top",
    "padding-bottom",
    "padding-inline",
    "padding-left",
    "padding-right"
  ],
  transitionDuration: ["transition-duration", "animation-duration"],
  zIndex: ["z-index"]
})
